<template>
  <nav :class="{ 'cont-nav': true, 'transparent-menu': navChange }">
    <div class="inner-nav">
      <img
        v-if="navChange"
        class="logo-nav"
        src="../assets/images/home/lo-1.png"
        alt=""
      />
      <img
        v-else
        class="logo-nav"
        src="../assets/images/home/lo.png"
        alt=""
      />
      <!-- <img class="logo-nav" src="../assets/images/home/logo.png" alt="" /> -->
      <el-menu
        :default-active="activeIndex"
        class="menu-nav"
        mode="horizontal"
        @select="handleSelect"
      >
        <template v-if="show">
          <el-menu-item index="1">首页</el-menu-item>
          <el-menu-item index="2">关于我们</el-menu-item>
          <el-menu-item index="9">主营业务</el-menu-item>
          <el-menu-item index="3">解决方案</el-menu-item>
          <el-menu-item index="4">项目案例</el-menu-item>
          <!-- <el-menu-item index="5">产品体验</el-menu-item> -->
          <el-menu-item index="6">新闻动态</el-menu-item>
          <el-menu-item index="7">加入我们</el-menu-item>
          <el-menu-item index="8">联系我们</el-menu-item>
          <!-- <el-menu-item index="10"><a href="http://112.125.93.159:8080/yyoa/index.jsp">  <el-button type="primary">OA登录</el-button></a> </el-menu-item> -->
         
           
          <!-- <el-submenu index="7">
            <template slot="title">关于我们</template>
            <el-menu-item index="7-1">核心技术</el-menu-item>
            <el-menu-item index="7-2">人才招聘</el-menu-item>
            <el-menu-item index="7-3">联系我们</el-menu-item>
          </el-submenu> -->
          <!-- <el-menu-item index="8">OA登录</el-menu-item> -->
        </template>
        <el-submenu v-else index="1">
          <template slot="title"
            ><img
              class="zd-pic"
              src="../assets/images/home/nav-icon.png"
              alt=""
          /></template>
          <el-menu-item index="1-1">首页</el-menu-item>
          <el-menu-item index="1-2">关于我们</el-menu-item>
          <el-menu-item index="1-9">主营业务</el-menu-item>
          <el-menu-item index="1-3">解决方案</el-menu-item>
          <el-menu-item index="1-4">项目案例</el-menu-item>
          <!-- <el-menu-item index="1-5">产品体验</el-menu-item> -->
          <el-menu-item index="1-6">新闻动态</el-menu-item>
          <el-menu-item index="1-7">加入我们</el-menu-item>
          <el-menu-item index="1-8">联系我们</el-menu-item>
           <!-- <el-menu-item index="1-10"><a href="http://112.125.93.159:8080/yyoa/index.jsp">  <el-button type="primary">OA登录</el-button></a> </el-menu-item> -->
          <!-- <el-submenu index="1-7">
            <template slot="title">关于我们</template>
            <el-menu-item index="1-7-1">核心技术</el-menu-item>
            <el-menu-item index="1-7-2">人才招聘</el-menu-item>
            <el-menu-item index="1-7-3">联系我们</el-menu-item>
          </el-submenu> -->
          <!-- <el-menu-item index="1-8">OA登录</el-menu-item> -->
        </el-submenu>
      </el-menu>
    </div>
  </nav>
</template>

<script>
import local from "../utils/local";
export default {
  name: "contnav",
  props: ["show","screenwidth"],
  data() {
    return {
      activeIndex: "1",
      screenHeight:document.documentElement.clientHeight,
      scrollTop:
        document.body.scrollTop ||
        document.documentElement.scrollTop ||
        window.pageYOffset,
    };
  },
  computed: {
    //控制导航样式
    navChange() {
      return (
        this.activeIndex == 1 && this.screenwidth>1200 && (this.scrollTop - this.screenHeight * 0.91) < 0
      );
    },
  },
  watch: {
    screenHeight(newValue) {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.scrollTop = newValue;
        this.timer = true;
        setTimeout(() => {
          this.timer = false;
        }, 400);
      }
    },
    scrollTop(newValue) {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer2) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.scrollTop = newValue;
        this.timer2 = true;
        setTimeout(() => {
          this.timer2 = false;
        }, 400);
      }
    },
    //监听相同路由下参数变化的时候，从而实现异步刷新
    $route(to, from) {
      console.log(to, from);
      //做一些路由变化的响应
      //重新获取数据
      this.navShow();
    },
  },
  mounted() {
    window.onresize = () => {
      // this.screenHeight =
      //   document.body.clientHeight || document.documentElement.clientHeight;
      this.screenHeight = document.documentElement.clientHeight;
      this.scrollTop =
        document.body.scrollTop ||
        document.documentElement.scrollTop ||
        window.pageYOffset;
    };
    window.addEventListener("scroll", () => {
      this.scrollTop =
        document.body.scrollTop ||
        document.documentElement.scrollTop ||
        window.pageYOffset;
    });
    this.navShow();
  },
  methods: {
    handleSelect(key) {
      local.remove("explainInfo")
      local.remove("sol")
      let options = {
        1: "/",
        "1-1": "/",
        2: "/profile",
        "1-2": "/profile",
        3: "/solution",
        "1-3": "/solution",
        4: "/cases",
        "1-4": "/cases",
        // "5":"/experience",
        // "1-5":"/experience",
        6: "/news",
        "1-6": "/news",
        7: "/recruitment",
        "1-7": "/recruitment",
        8:"/contactus",
       "1-8":"/contactus",
        // "7-1":"/core",
        // "1-7-1":"/core",
        // "7-2":"/recruitment",
        // "1-7-2":"/recruitment",
        // "7-3":"/contactus",
        // "1-7-3":"/contactus",
        9: "/business",
        "1-9": "/business",
      };
      options[key] && this.$router.push(options[key]);
      // zhl-----------------
      let localPath = options[key].slice(1)
      local.set("prePath",localPath)
    },
    navShow() {
      // 处理导航选中位置
      let name = this.$route.name;
      // if (name == "detail") {
      //   if (this.$route.query.footerType == 1) {
      //     name = "cases";
      //   } else if (this.$route.query.footerType == 2) {
      //     name = "solution";
      //   } else if (local.get("prePath")) {
      //     name = local.get("prePath");
      //   }
      // }
      if (name == "detail") {
        if (this.$route.query.footerType == 1) {
          name = "cases";
        } else if (this.$route.query.footerType == 2) {
          name = "solution";
        }else if (this.$route.query.footerType == 3) {
          name = "business";
        } else if (local.get("prePath")) {
          name = local.get("prePath");
        }
      }
      switch (name) {
        case "home":
          this.activeIndex = "1";
          break;
        case "profile":
        case "honor":
          this.activeIndex = "2";
          break;
        case "solution":
          this.activeIndex = "3";
          break;
        case "cases":
          this.activeIndex = "4";
          break;
        // case "experience":
        //   this.activeIndex = "5";
        //   break;
        case "news":
          this.activeIndex = "6";
          break;
        case "recruitment":
          this.activeIndex = "7";
          break;
          case "contactus":
          this.activeIndex = "8";
          break;
        // case "core":
        // case "recruitment":
        // case "contactus":
        //   this.activeIndex = "7";
        //   break;
        case "business":
          this.activeIndex = "9";
          break;
        // case "detail":
        //   if (this.$route.query.footerType == 1) {
        //     this.activeIndex = "4";
        //   } else if (this.$route.query.footerType == 2) {
        //     this.activeIndex = "3";
        //   }
        //   break;
        default:
          this.activeIndex = "1";
          break;
      }

    },
  },
};
</script>

<style scoped lang="less">
@import "../assets/less/public.less";
.cont-nav {
  width: 100%;
  border-bottom: 1px solid #efefef;
  background-color: #fff;
  position: fixed;
  z-index: 100;
  transition: all 0.5 ease;
  .inner-nav {
    // width: 86%;
    width: 92%;
    // max-width: 1500px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .logo-nav {
      max-width: 330px;
      min-width: 180px;
      width: 22vw;
    }
    .zd-pic {
      background-color: #409eff;
    }
  }
}
// 标签标签页
/deep/.el-tabs__nav-wrap::after {
  background-color: transparent;
}
/deep/.el-tabs__item {
  padding: 0 8px !important;
}
/deep/.el-tabs__active-bar {
  display: none;
}
/deep/ .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  color: @color-select1;
}

// 导航菜单
/deep/.el-menu--popup-right-start {
  min-width: 5.5rem;
}
/deep/.el-menu--popup-right-start .el-menu-item {
  min-width: 5.5rem;
}
.is-opened /deep/.el-menu--horizontal {
  right: 10px !important;
  width: 100px !important;
  z-index: 10000;
}
.el-menu.el-menu--horizontal {
  border: none;
  // padding-right: 5.75rem;
}
// /deep/.el-menu--horizontal > .el-submenu.is-active .el-submenu__title,
// /deep/.el-menu--horizontal > .el-submenu:hover .el-submenu__title {
//   color: @color-select1!important;
// }
// /deep/.el-menu--horizontal > .el-submenu .el-submenu__title {
//   color: @color-default;
// }
.el-menu--horizontal .el-menu-item:not(.is-disabled):hover,
.el-menu--horizontal > .el-menu-item.is-active {
  color: #0e6cb6 !important;
  border-color: transparent;
}
.el-menu--horizontal > .el-menu-item {
  color: #333333;
}
.el-menu-item,
/deep/.el-submenu__title {
  // font-size: 22px;
  color: @color-default;
  padding: 0 11px;
}
.el-menu-item:last-child {
  padding-right: 0;
}


@media screen and (min-width: 1200px) {
  /deep/.el-menu--horizontal > .el-submenu .el-submenu__title {
    height: 11vh;
    line-height: 11vh;
  }
  /deep/.el-menu--horizontal > .el-menu-item {
    height: 11vh;
    line-height: 11vh;
  }

  // 首页透明导航部分
  .transparent-menu {
    // background-color: transparent !important;
    background-color: rgba(#000000, 0.1);
    border: none;
    /deep/.el-menu {
      background: none;
    }
    /deep/.el-menu--horizontal > .el-menu-item:not(.is-disabled):hover {
      background-color: transparent;
    }
    /deep/.el-menu--horizontal > .el-menu-item {
      color: #ffffff;
    }
  }
  .el-menu-item,
  /deep/.el-submenu__title {
    font-size: 22px;
  }
}
@media screen and (min-width: 768px) and (max-width: 1200px) {
  /deep/.el-menu--horizontal > .el-submenu .el-submenu__title {
    height: 10vh;
    line-height: 10vh;
  }
  /deep/.el-menu--horizontal > .el-menu-item {
    height: 10vh;
    line-height: 10vh;
  }
  /deep/.el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
    border-bottom: none;
  }
  /deep/.el-icon-arrow-down:before {
    content: "";
  }
  .el-menu-item,
  /deep/.el-submenu__title {
    font-size: 18px;
  }
}
@media screen and (min-width: 414px) and (max-width: 768px) {
  /deep/.el-menu--horizontal > .el-submenu .el-submenu__title {
    height: 64px;
    line-height: 64px;
  }
  /deep/.el-menu--horizontal > .el-menu-item {
    height: 64px;
    line-height: 64px;
  }
  /deep/.el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
    border-bottom: none;
  }
  /deep/.el-icon-arrow-down:before {
    content: "";
  }
  .el-menu-item,
  /deep/.el-submenu__title {
    font-size: 16px;
  }
}
@media screen and (max-width: 414px) {
  /deep/.el-menu--horizontal > .el-submenu .el-submenu__title {
    height: 44px;
    line-height: 44px;
  }
  /deep/.el-menu--horizontal > .el-menu-item {
    height: 44px;
    line-height: 44px;
  }
  /deep/.el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
    border-bottom: none;
  }
  /deep/.el-icon-arrow-down:before {
    content: "";
  }
  .el-menu-item,
  /deep/.el-submenu__title {
    font-size: 16px;
  }
}
</style>
